/// <reference types="react" />
import { createElement as h } from 'react';

export default function SignificanceChart() {
  return h('div', { style: { padding: 16, background: '#f8f9fa', borderRadius: 8 } },
    h('h3', null, 'Statistical Significance'),
    h('p', { style: { color: '#888' } }, 'Chart will be available when A/B test data is collected.'),
  );
}
